var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.06278 10.386L6.76578 14.5743C7.19215 14.5743 7.37553 14.391 7.59716 14.1716L9.59403 12.2625L13.7329 15.2932C14.4912 15.7162 15.0267 15.4935 15.2314 14.5946L17.9483 1.86635L17.9494 1.86522C18.1902 0.743599 17.5444 0.304849 16.8042 0.580473L0.835906 6.6926C-0.253094 7.11559 -0.237344 7.72309 0.650281 7.99872L4.73178 9.26884L14.2144 3.3356C14.661 3.03972 15.066 3.20397 14.733 3.49872L7.06278 10.386Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.1affac5d2c899f2a428e9b3eb2993a41.svg";
export { ForwardRef as ReactComponent };